import $ from 'jquery';
import moment from 'moment/moment';
import * as amplitude from '@amplitude/analytics-browser';
import store from '../store';

/*************************
 App Header
 *************************/
export function appheader() {
  $('.mobile-toggle').on('click', function () {
    $('body').toggleClass('sidebar-toggled');
  });

  $(document).on('click', '.mega-menu.dropdown-menu', function (a) {
    a.stopPropagation();
  });

  $('.sidebar-toggle').on('click', function () {
    $('body').toggleClass('sidebar-mini');
    $('.app-navbar').toggleClass('expand');
  });
}

/*************************
 SidebarNav
 *************************/
export function sidebarNav() {
  var sidebarNav = $('.sidebar-nav');
  if (sidebarNav.length > 0) {
    (function (window, document, $) {
      $(function () {
        if (sidebarNav.length > 0) {
          $('#sidebarNav').metisMenu();
        }
      });
    })(window, document, $);
  }
}

/*************************
 SidebarNav
 *************************/
export function appNavBar() {
  $('.app-navbar').hover(function () {
    if ($('body').hasClass('sidebar-mini')) $('.app-wrap').toggleClass('expand-navbar');
  });
}

/**********
 * Remove Empty params
 ***********/
export function removeEmptyParams(params) {
  if (!params) return params;
  for (const key of Object.keys(params)) {
    if (params[key] === undefined || params[key] === null || params[key] === '') {
      delete params[key];
    }
  }
  return params;
}

/**********
 * Remove Empty params
 ***********/
export function dateToUtc(date) {
  return moment(date).utc(true).toDate();
}

export function formatToUtc(date) {
  return moment(date).utc(true).format();
}

export function transformDownloadResponse(data) {
  return data;
}

/********
 * Go back
 ********/
export function goBack(router) {
  if (window.history.length > 2) {
    router.go(-1);
  } else {
    router.push('/');
  }
}

/********
 * Back to
 ********/
export function goBackTo(router, route) {
  router.push({name: route});
}

export function createFormDataFiles(obj, files) {
  let formData = new FormData();
  formData.append(
    'item',
    new Blob([JSON.stringify(obj)], {
      type: 'application/json',
    }),
  );
  if (files)
    Array.from(files).forEach((f) => {
      formData.append('files', f);
    });
  return formData;
}

export function createFormDataFile(obj, file) {
  let formData = new FormData();
  formData.append(
    'item',
    new Blob([JSON.stringify(obj)], {
      type: 'application/json',
    }),
  );
  formData.append('file', file);
  return formData;
}

export function createFormDataFic(tableName, tableId, files) {
  let formData = new FormData();
  formData.append(
    'item',
    new Blob([JSON.stringify({tableName: tableName, tableId: tableId})], {
      type: 'application/json',
    }),
  );
  Array.from(files).forEach((f) => {
    formData.append('files', f);
  });
  return formData;
}

export function createFormDataFicForUser(file) {
  let formData = new FormData();
  formData.append('file', file);
  return formData;
}

/*********
 *
 * SWAP TWO ITEMS IN A LIST
 *********/
export function swap(arr, from, to) {
  if (arr.length < from || arr.length < to) return;
  if (from < 0 || to < 0) return;
  arr.splice(from, 1, arr.splice(to, 1, arr[from])[0]);
}

/*********
 *
 * Debounce
 *********/

export const debounce = (func, delay = 600, immediate = false) => {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
    if (callNow) func.apply(context, args);
  };
};

export function checkImageBeforeUpload(file, minWidth, minHeight, minSizeKB, maxSizeMB) {
  return new Promise((resolve, reject) => {
    if (!file || !(file instanceof File)) {
      reject(new Error('Aucun fichier ou type de fichier incorrect'));
      return;
    }

    // Vérification du poids
    const fileSizeKB = file.size / 1024;
    const fileSizeMB = file.size / (1024 * 1024);

    if (fileSizeKB < minSizeKB) {
      reject(new Error(`Le fichier est trop léger. Taille minimale requise : ${minSizeKB} Ko.`));
      return;
    }
    if (fileSizeMB > maxSizeMB) {
      reject(new Error(`Le fichier est trop volumineux. Taille maximale autorisée : ${maxSizeMB} Mo.`));
      return;
    }

    // Vérification des dimensions
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        if (img.width >= minWidth && img.height >= minHeight) {
          resolve(true);
        } else {
          reject(
            new Error(
              `La résolution de l'image est insuffisante. Minimum requis : ${minWidth}x${minHeight}. Image actuelle : ${img.width}x${img.height}`,
            ),
          );
        }
      };
      img.onerror = () => {
        reject(new Error("Impossible de charger l'image"));
      };
      img.src = e.target.result;
    };
    reader.onerror = () => {
      reject(new Error('Impossible de lire le fichier'));
    };
    reader.readAsDataURL(file);
  });
}

export async function validateFiles(files, minWidth, minHeight, minSizeKB, maxSizeMB) {
  const validFiles = [];
  const errors = [];

  const validations = Array.from(files).map(async (file) => {
    try {
      await checkImageBeforeUpload(file, minWidth, minHeight, minSizeKB, maxSizeMB);
      validFiles.push(file);
    } catch (error) {
      errors.push({
        file,
        message: error.message,
      });
    }
  });

  await Promise.all(validations);
  return {validFiles, errors};
}

export function initAmplitude() {
  if (import.meta.env.VUE_APP_YOUSIGN_PLATFORM === 'prod') {
    amplitude.init(
      '2c357753a2d7c3b1a0c70222ab7895dd',
      import.meta.env.VUE_APP_YOUSIGN_PLATFORM === 'prod'
        ? store.state.userInformation.email
        : import.meta.env.VUE_APP_YOUSIGN_PLATFORM + '_' + store.state.userInformation.email,
      {
        autocapture: true,
        serverZone: 'EU',
        identityStorage: 'localStorage',
      },
    );
    const identifyEvent = new amplitude.Identify();
    identifyEvent.setOnce('role', store.state.userInformation.roleKey);
    identifyEvent.setOnce('plateforme', import.meta.env.VUE_APP_YOUSIGN_PLATFORM);
    amplitude.identify(identifyEvent);
  }
}
